export type StringType = typeof svStrings | Record<string, Record<string, string>>;

const svStrings = {
  menu: {
    apps: 'Appar',
    pushDashboard: 'Pushnotiser',
    polls: 'Omröstningar',
    videoPortraits: 'Porträttvideor',
    matches: 'Matcher',
    mappings: 'Mappning',
    news: 'Nyheter',
    eventEffects: 'Händelser',
    wifi: 'Wifi',
    timeMachine: 'Tidsmaskin',
    eventLog: 'Loggar',
    messageViewer: 'Meddelande',
    squad: 'Trupper',
    allPlayers: 'Alla spelare',
    staff: 'Ledare & Personal',
    ticketConfigurator: 'Biljetter',
    usersAndPermissions: 'Användare',
    socialInteractions: 'Sociala interaktioner',
    articles: 'Artiklar',
    userExplorer: 'Kontoinformation',
    userManual: 'Manual',
    faq: 'FAQ',
    superAdmin: 'Superadmin',
    promos: 'Promos',
    sceneConfigs: 'Moduler i app',
    appMenu: 'Menykonfiguration',
    theme: 'Färgtema',
    linksInfo: 'Länkar & information',
    videoPlayer: 'Sponsor videospelaren',
    support: 'Support',
    arena: 'Arena',
    teamData: 'Laginformaton',
    appContent: 'Appinnehåll',
    appSettingsTheme: 'Appinställningar och tema',
    teamArena: 'Lag och arena',
    userAndManual: 'Användare och manual',
    announcements: 'Meddelanden',
  },
  appBar: {
    apps: 'Appar',
    app: 'App',
    appDetails: 'Appdetaljer',
    appMenu: 'Menykonfiguration',
    sceneConfigs: 'Moduler i app',
    appConfig: 'Inställningar',
    theme: 'Färgtema',
    linksInfo: 'Länkar & information',
    videoPlayer: 'Sponsor videospelaren',
    support: 'Support',
    arena: 'Arena',
    teamData: 'Laginformaton',
    messageViewer: 'Meddelande',
    pushNotificationLog: 'Pushnotiser',
    pushNotificationSchedule: 'Schemalägg pushnotiser',
    pushDashboard: 'Pushnotiser',
    matches: 'Matcher',
    matchDetails: 'Information',
    matchStats: 'Statistik',
    matchLineup: 'Laguppställning',
    matchEvents: 'Händelser',
    news: 'Nyheter',
    polls: 'Omröstningar',
    articles: 'Artiklar',
    fcmTopicExplorer: 'Utforska FCM ämnen',
    timeMachine: 'Tidsmaskin',
    usersAndPermissions: 'Användare och rättigheter',
    socialInteractions: 'Sociala interaktioner',
    eventLog: 'Loggar',
    eventEffects: 'Händelser',
    account: 'Konto',
    squad: 'Trupp',
    allPlayers: 'Alla spelare',
    theSquad: 'Trupper',
    stories: 'Porträttvideor',
    social: 'Sociala interaktioner',
    faq: 'FAQ',
    superAdmin: 'Superadmin',
    promos: 'Promos',
    staff: 'Ledare & Personal',
    mappings: 'Mappning',
    tickets: 'Biljetter',
    wifi: 'Wifi',
    accountInfo: 'Kontoinformation',
    announcements: 'Meddelanden',
  },
  sceneConfig: {
    toolbar: 'Verktygsfält',
    scene: 'Scen',
    preview: 'Förhandsgranska',
    mobile: 'Mobil',
    tablet: 'Platta',
    both: 'Båda',
    availableComponents: 'Tillgängliga komponenter',
  },
  actions: {
    ok: 'Ok',
    publish: 'Publicera',
    publishNow: 'Publicera nu',
    publishChanges: 'Publicera ändringarna',
    submit: 'Skicka',
    validate: 'Validera',
    validateRss: 'Validera RSS',
    uploadImage: 'Ladda upp bild',
    uploadImages: 'Ladda upp bilder',
    removeImage: 'Ta bort bild',
    cancel: 'Avbryt',
    upload: 'Ladda upp',
    back: 'Tillbaka',
    filterByApp: 'Filtrering med app',
    done: 'Klart',
    next: 'Nästa',
    previous: 'Föregående',
    enter: 'Öppna',
    search: 'Sök',
    save: 'Spara',
    archive: 'Arkivera',
    add: 'Lägg till',
    edit: 'Editera',
    accept: 'Acceptera',
    dismiss: 'Avböj',
    logout: 'Logga ut',
    yes: 'Ja',
    no: 'Nej',
    yesContinue: 'Ja, fortsätt',
    noCancel: 'Nej, avbryt',
    close: 'Stäng',
    delete: 'Ta bort',
    show: 'Visa mer',
    hide: 'Göm',
    preview: 'Förhandsgranska',
    saveAndPreview: 'Spara och förhandsgranska',
  },
  validations: {
    isRequired: 'Måste fyllas i',
    validImage: 'Bilden har inte ett korrekt format',
    validUrl: 'Ange en giltig url, tex https://www.svenskelitfotboll.se',
    validDate: 'Ange ett giltigt datum',
    validDateTime: 'Ange ett giltigt datum och tid',
    validDateInPast: 'Valt datum kan inte vara bakåt i tiden',
    validDateIn: 'Valt datum kan inte vara i framtiden',
    validDateInFuture: 'Valt datum kan inte vara i framtiden',
    validDateStartBeforeEnd: 'Sluttiden får inte vara före starttiden',
    validIPRange: 'Ej giltigt IP-intervall',
    validEmail: 'Ange en giltig e-postadress',
    validPhoneNumber: 'Ange ett giltigt telefonnummer',
    validPushNotificationTitleMaxLength: 'Det är tillåtet med upp till 65 tecken',
    validPushNotificationDescriptionMaxLength: 'Det är tillåtet med upp till 150 tecken',
    validNewsRSS: 'Nyheter saknas',
    validNewsRSSImage: 'Bild till nyheterna saknas',
    validNewsRSSTitle: 'Titel till nyheterna saknas',
    validNewsRSSLink: 'Länk till nyheterna saknas eller är ogltig (tex https:// saknas)',
    validFotbollPlayUrl:
      'Ange en giltig url till ett videoklipp från Fotboll Play, tex https://fotbollplay.se/playlist/av5u6sb7vfn8r',
    validFotbollPlayVideoPortrait: 'Videon har inte ett korrekt porträttformat',
    validFotbollPlayVideoPayment: 'Videon är bakom en betalvägg och kan inte användas just nu',
    mustBeAtleast3Chars: 'Måste vara minst tre bokstäver',
    mustBeBarcodeValues: 'Måste vara något av följande värde: aztec, code123, qr',
    mustBePromoValues: 'Måste vara något av följande värde: Image, Web view, Google Ad Manager',
    mustBeInteger: 'Måste vara ett heltal',
    mustBePositive: 'Måste vara positivt',
    mustBeMinimum: 'Måste vara mer än ',
    mustBeFollowingValues: 'Måste vara ett av följande värde:',
    mustSelectTarget: 'Måste välja ett mål',
    mustSelectAlternative: 'Måste välja ett alternativ',
    mustSelectAtleastOneAlternative: 'Måste välja minst ett alternativ',
    validQuizRewardThresholdAtLeast: 'Måste vara minst 1',
    validQuizRewardThresholdMoreThan: 'Får inte vara mindre än 0',
    validQuizRewardMessageMaxLength: 'Det är tillåtet med upp till 500 tecken',
    validQuizRewardVoucherCodeMaxLength: 'Det är tillåtet med upp till 50 tecken',
  },
  messages: {
    uploadSuccess: 'Uppladdningen lyckades',
    uploadError: 'Uppladdningen misslyckades',
    uploadErrorImage: 'Uppladdningen misslyckades. Försök igen med en annan bild',
    resolveErrors: 'Problemen måste lösas innan publisering',
    saveSuccess: 'Sparningen lyckades',
    saveError: 'Sparningen misslyckades',
    deleteSuccess: 'Borttagning lyckades',
    deleteError: 'Borttagning misslyckades',
    loadingError: 'Laddningen misslyckades',
    validateSuccess: ' Valideringen lyckades',
    validateError: 'Valideringen misslyckades',
    findUserError: 'Användaren hittades inte',
    exportSuccess: ' Exporteringen lyckades',
    exportError: 'Exporteringen misslyckades',
    imageTooLargeError: 'Bilden är större än den rekommenderade storleken',
    imageTooSmallError: 'Bilden är mindre än den rekommenderade storleken',
    loading: 'Laddar...',
    serverError: 'Serverfel',
    error: 'Ett fel uppstod',
    permissionError: 'Du måste vara admin för att använda denna funktionen',
    checkingSignedInUser: 'Verifierar inloggad användare...',
    none: 'Ingen',
    invalidValue: 'Ogiltigt värde',
    scheduledPushNotification: 'Pushnotisen är nu schemalagd',
    sendPushNotification: 'Pushnotisen är nu skickad',
    dragAndDropImage: 'Dra och släpp bilden här eller klicka här för att välja en bild',
    dragAndDropImages: 'Dra och släpp bilderna här eller klicka här för att välja bilderna',
    noArenaFound: 'Det finns ingen arena tillgänglig för klubben',
    newsHiddenSuccess: 'Nyheten är nu dold och visas inte i appen',
    newsShowSuccess: 'Nyheten är nu inte dold längre och visas i appen',
    newsHiddenCommentsSuccess: 'Kommentarer är nu dolda för nyheten',
    newsShowCommentsSuccess: 'Kommentarer är nu inte längre dolda för nyheten',
    pushNotificationSuccess: 'Sparningen lyckades',
    segmentSuccess: 'Sparningen lyckades',
    commentHiddenSuccess: 'Kommentaren är nu dold och visas inte i appen',
    commentShowSuccess: 'Kommentaren är nu inte dold längre och visas i appen',
    storyHiddenSuccess: 'Porträttvideon är nu dold',
    storyShowSuccess: 'Porträttvideon är inte dold längre',
    commentsDisabled: 'Kommentarer är nu avstängda',
    commentsEnabled: 'Kommentarer är nu påslagna',
    reactionsDisabled: 'Reaktioner är nu avstängda',
    reactionsEnabled: 'Reaktioner är nu påslagna',
    promoRatioError:
      'De valda bilderna i din exponeringsyta har olika höjd. Vi rekommenderar att du kontrollerar "Förhandsgranska" innan publicering så resultatet blir som du tänkt dig',
  },
  fields: {
    // Team information
    titleTeam: 'Information',
    teamName: 'Lagnamn',
    teamSquadImage: 'Lagbild',
    teamImage: 'Bild',
    teamAbbrv: 'Förkortning',
    teamShortName: 'Kort namn',
    teamLogo: 'Logga',
    teamFeedLogo: 'Nyhetslogo',
    teamHeaderBackground: 'Bakgrundsbild',
    teamDisabledLiveVideo: 'Live video avstängd',
    teamArenaBarcode: 'Arena streckkod',
    teamYear: 'År',
    teamGAkey: 'Google Analytics-nyckel',
    appStoreLink: 'App Store länk',
    googlePlayLink: 'Google Play länk',
    appPromoImage: 'App Promo bild',
    appPromoText: 'App Promo text',
    appName: 'App namn',
    videoPlayerLeaguePartner: 'Partner Branding Logo',
    videoPlayerClubPartner: 'Club Branding Logo',
    currentSeason: 'Säsong',
    leagueName: 'Liga',
    hasClubstreams: 'Använd Antourage Clubstreams',
    // Lottery
    titleLottery: 'Lotteri',
    lotteryArenaCoordinates: 'Arenakordinater',
    lotteryArenaGpsRadius: 'Arena GPS radie',
    lotteryEnabled: 'Påslagen',
    //...
    // Live stream
    titleLiveStream: 'Live stream med Antourage',
    streamBackgroundCard: 'Bakgrundskort',
    // Arena
    titleArena: 'Arena',
    arenaUpcomingImage: 'Kommande bild',
    arenaOriginalImage: 'Originalbild',
    arenaMatchUpcomingImage: 'Kommande matchbild',
    arenaOngoingImage: 'Pågående matchbild',
    arenaFinishedImage: 'Avslutad matchbild',
    arenaName: 'Arenanamn',
    arenaSpectators: 'Kapacitet',
    arenaBuilt: 'Byggnadsår',
    arenaRecord: 'Publikrekord',
    // League Sponsor
    titleLeagueSponsor: 'Ligapartner',
    sponsorImage: 'Bild',
    sponsorUrl: 'Länk',
    sponsorColor: 'Färg',
    // Promos
    titlePromos: 'Kampanjer',
    promoImage: 'Bild',
    promoVariant: 'Variant',
    promoLink: 'Promolänk',
    promoGameLink: 'Spellänk',
    promoOpen: 'Öppna promo i app',
    promoTimedStart: 'Välj starttid',
    promoTimedEnd: 'Välj sluttid',
    promoRestriction: 'Åldersgräns',
    promoVariantImage: 'Bild',
    promoVariantSubscription: 'Prenumeration',
    promoVariantVideo: 'Video',
    promoVariantPoll: 'Omröstning',
    promoVariantFlarie: 'Flarie',
    promoVariantNone: 'Ingen',
    promoHeight: 'Längd',
    promoWidth: 'Bredd',
    promoTitle: 'Titel',
    promoPoll: 'Omröstning',
    promoPollNone: 'Ingen omröstning',
    // Application theme
    titleAppTheme: 'Tema',
    themeIdMain: 'ID',
    themeIdForeground: 'Förgrund',
    themeIdContrast: 'Kontrast',
    themeComponentBackground: 'Komponent bakgrund',
    themeComponentForeground: 'Komponent förgrund',
    themeComponentBorder: 'Komponent ram',
    themeComponentForegroundId: 'Komponent ID',
    themeButtonBackground: 'Knapp bakgrund',
    themeButtonForeground: 'Knapp förgrund',
    themeTopBarBackground: 'Topbar bakgrund',
    themeTopBarForeground: 'Topbar förgrund',
    themeTopBarContrast: 'Topbar kontrast',
    themeSocialHeart: 'Hjärta',
    themeTopBarOverride: 'Använd Topbar färger',

    // Team links
    titleTeamLinks: 'Länkar',
    linksHomePageLink: 'Hemsida länk',
    linksHomePageIcon: 'Hemsida ikon',
    linksShopLink: 'Butik länk',
    linksShopIcon: 'Butik ikon',
    linksPlayLink: 'Spela länk',
    linksPlayIcon: 'Spela ikon',
    linksFacebookLink: 'Facebook länk',
    linksFacebookIcon: 'Facebook ikon',
    linksInstagramLink: 'Instagram länk',
    linksInstagramIcon: 'Instagram ikon',
    linksTwitterLink: 'Twitter länk',
    linksTwitterIcon: 'Twitter ikon',
    linksTV4: 'TV4',
    linksPolicy: 'Integritetspolicyn länk',
    // Video player branding
    titleVideoBranding: 'Branding av videospelare',
    brandingPartnerLogo: 'Ligapartner logga',
    brandingClubLogo: 'Klubbpartner logga',
    brandingClubStreams: 'Använd Antourage Clubstreams',
    // Support
    titleSupport: 'Support',
    ticketSupportEmail: 'Email för biljettsupport',
    ticketSupportEmailHelper:
      'E-postadressen som användare kan kontakta vid frågor eller problem med biljetter.',
    infoEmail: 'Email för info',
    infoEmailHelper: 'E-postadressen som användare kan kontakta vid allmänna frågor.',
    appEmail: 'Email för appfrågor',
    appEmailHelper: 'E-postadressen som användare kan kontakta vid frågor om appen.',
    supportPhoneNumber: 'Telefonnummer för support',
    supportPhoneNumberHelper:
      'Telefonnumret som användare kan ringa för support, tex +46 8 123 456 78.',
    // Team info
    titleTeamInfo: 'Lagdata',
    teamInfoName: 'Titel',
    teamInfoValue: 'Värde',
    teamInfoAbbrvAliases: 'Abbrv Aliases',
    // Technical setup
    titleSetup: 'Tekniska inställningar',
    // News
    titleNews: 'Nyheter',
    newsRSSLink: 'Nyheter RSS länk',
    newsRSSValidate: 'Validera',
  },
  sceneFields: {
    geoRestricted: 'Geografiskt begränsad',
    label: 'Text',
    listLimit: 'Antal i listan',
    tableType: 'Typ av tabell',
    backgroundLight: 'Ljus',
    backgroundDark: 'Mörk',
    backgroundApp: 'App',
    backgroundNone: 'Ingen',
    goals: 'Mål',
    assists: 'Assists',
    goalsAndAssists: 'Mål och assists',
    category: 'Kategori',
    channels: 'Kanaler',
    selectPromo: 'Välj promo',
    selectPromoMultiple: 'Välj promos (max 3 st)',
    isTimed: 'Tidsinställd',
    selectPoll: 'Välj omröstning',
    matchListButton: 'Visa spelschema-knapp',
    ticketButton: 'Visa biljett-knapp',
    openInApp: 'Öppna i appen',
    url: 'URL',
    redirectUrl: 'Redirect URL',
    aspectRatio: 'Bildförhållande',
    width: 'Bredd',
    height: 'Höjd',
    dId: 'dId',
    adId: 'adId',
  },
  pushFields: {
    titleTarget: 'Målgrupp',
    initialSelectApp: 'Välj app',
    initialSelectTarget: 'Välj målgrupp',
    initialOptionVisitors: 'Arenabesökare',
    initialOptionAllUsers: 'Alla användare',
    // Content
    titleContent: 'Innehåll',
    contentTitle: 'Titel',
    contentMessage: 'Meddelande',
    contentNotificationImage: 'Notifikationsbild',
    // Date
    titleDate: 'Datum och tid',
    dateTitle: 'Datum',
    // Schedule
    titleSchedule: 'Schemalägg',
    scheduleTitle: 'Välj tidpunkt',
    sendImmediately: 'Snarast',
    sendLater: 'Senare',
    // Channels
    titleChannels: 'Kanaler',
    channelsVisitorsFollowingDate: 'Arenabesökare datum',
    channelsDefaultApp: 'Standard kanal-appar',
    channelsOptionDefault: 'Standard',
    // Destination
    titleDestination: 'Destination',
    destinationText: 'Välj vilken typ av destination som pushen skall leda användaren till',
    destinationLabel: 'Välj destination',
    destinationOptionWebUrl: 'Extern web url',
    destinationOptionApp: 'Innehåll i appen',
    destinationWebUrlLabel: 'Ange extern url',
    destinationWebUrlHelperText: 'En web url som öppnas i appen, tex. https://www.damfotboll.se',
    destinationAppLabel: 'Välj innehåll i appen',
    destinationAppOptionScene: 'Startscen',
    destinationAppOptionMatch: 'Match',
    destinationAppOptionPoll: 'Omröstning',
    destinationMatchLabel: 'Välj match',
    destinationPollLabel: 'Välj omröstning',
  },
  usersFields: {
    users: 'Användare',
    permissions: 'Rättigheter',
    edit: 'Editera',
    superadmin: 'Superadmin',
    delete: 'Ta bort',
  },
  apps: {
    tabAll: 'Alla',
    tabTeam: 'Lag-appar',
    tabLeague: 'Liga-appar',
    noPermission: 'Du har inte rättighet att se eller editera appar',
    incomingChange: 'Konfigurationen har ändrats av $author. Vill du behålla dina ändingar?',
    unknown: 'någon annan',
  },
  pushNotifications: {
    title: 'Pushnotiser',
    pushTitleLog: 'Skickade och schemalagda Pushnotiser',
    pushTitleSchedule: 'Schemalägg Pushnotiser',
    pushTitleExplore: 'Utforska FCM ämnen',
    pushNotificationsScheduled: 'Pushnotiserna är schemalagda',
    selectChannels: 'Välj kanaler',
    fieldNameDate: 'Datum',
    fieldNameApp: 'App',
    fieldNameType: 'Typ',
    fieldNameId: 'Id',
    fieldNameImage: 'Bild',
    fieldNameTitle: 'Titel',
    fieldNameMessage: 'Meddelande',
    fieldNameChannels: 'Kanaler',
    fieldNameCondition: 'Villkor',
    fieldNameAuthor: 'Författare',
    fieldNameTarget: 'Mål',
    fieldNameUnschedule: 'Ej schemalagt',
    fieldStats: 'Stats',
    tabSendPush: 'Skicka',
    tabAutomatedPush: 'Automated',
    tabManualPush: 'Manual',
    tabExploreFCM: 'FCM data',
    pushNotificationSettingsTitle: 'Pushnotisinställningar',
    pushNotificationSettings: 'Inställningar',
    pushNotificationSegmentsTitle: 'Målgrupper för pushnotiser',
    pushNotificationSegments: 'Hantera målgrupper',
    sendPushLater: 'Schemalägg',
    sendPushNow: 'Skicka nu',
    leagueApps: 'Liga-appar',
    sentWithinMin: 'Meddelandet skickas inom 10 minuter',
    selectApp: 'Välj app',
    selectType: 'Välj typ',
    selectStatus: 'Välj status',
    selectSegment: 'Välj målgrupp',
    labelScheduled: 'Schemalagda',
    labelNews: 'Nyheter',
    labelMatchEvents: 'Matchhändelser',
    labelMatchEventsHiglightsPlus: 'Matchhändelser H+',

    settingsContent: 'Innehåll',
    settingsDescription: 'Beskrivning',
    settingsPushNotificationTitle: 'Notis-titel',
    settingsPushNotificationMessage: 'Notis-meddelande',
    settingsPushNotificationAutomation: 'AUTO. Pushnotiser',

    ARTICLES: 'Artiklar',
    POLL: 'Omröstningar',
    STORIES: 'Porträttvideo',
    MATCH: 'Matcher',
    NEWS: 'Nyheter',
    WEB_PAGE: 'Extern web url',

    status: 'Status',
    SENT: 'Skickat',
    SCHEDULED: 'Schemalagda',
    FAILED: 'Misslyckades',

    when: 'När',
    whenImmediately: 'Omgående',
    whenScheduled: 'Schemalagda',

    articlesSettingsTitle: 'Artiklar',
    pollsSettingsTitle: 'Omröstningar',
    videosSettingsTitle: 'Porträttvideo',
    matchesSettingsTitle: 'Matcher',
    newsSettingsTitle: 'Nyheter',

    articlesSettingsDescription:
      'Om pushnotiser är aktiverat för artiklar kommer varje ny artikel generera en ny notis i appen. ',
    pollsSettingsDescription:
      'Om pushnotiser är aktiverat för omröstningar kommer varje ny artikel generera en ny notis i appen. ',
    videosSettingsDescription:
      'Om pushnotiser är aktiverat för porträttvideo kommer varje ny artikel generera en ny notis i appen. ',
    matchesSettingsDescription:
      'Om pushnotiser är aktiverat för matcher kommer varje händelse i en match generera en ny notis i appen. ',
    newsSettingsDescription:
      'Om pushnotiser är aktiverat för artiklar kommer varje ny artikel generera en ny notis i appen. ',

    articlesSettingsTitleSelection: 'Artikelrubrik',
    pollsSettingsTitleSelection: 'Titel/Fråga',
    videosSettingsTitleSelection: 'Caption',
    matchesSettingsTitleSelection: 'Titel',
    newsSettingsTitleSelection: 'Titel',

    articlesSettingsDescriptionSelection: 'Beskrivning',
    pollsSettingsDescriptionSelection: 'Typ',
    videosSettingsDescriptionSelection: 'Typ',
    matchesSettingsDescriptionSelection: 'Resultat',
    newsSettingsDescriptionSelection: 'Beskrivning',

    addSegmentButton: 'Ny målgrupp',
    segmentsName: 'Namn',
    segmentsDescription: 'Beskrivning',
    segmentsSource: 'Källa',
    segmentsCreatedAt: 'Skapad',

    optionSegmentALL_USERS: 'ALLA',
    optionSegmentALL_USERS_WITH_POSITION: 'ALL_WITH_POSITION',
    optionSegmentCSV: 'CSV',
    optionSegmentPOLL: 'Omröstning/Quiz',
    segmentPollParticipants: 'Alla deltagare',
    segmentPollWinners: 'Vinnare',
    segmentPollPickRANDOM: 'slumpat',
    segmentPollPickEARLIEST: 'först in',
    segmentPollSummary: '$audience – $count av $total',
    selectSourceFile: 'Väl källfil',

    newSegment: 'Ny målgrupp',
    editSegment: 'Målgrupp',
    saveSegment: 'Skapa målgrupp',

    users: 'användare',
    deleteButton: 'Radera målgrupp',

    statusNotSent: 'Ej skickad',
    statusSent: 'Skickad',
    statusScheduled: 'Planerad',

    loading: 'Laddar...',

    pushNotificationSaveButton: 'Uppdatera notis',
    pushNotificationCreateButton: 'Skapa notis',
    pushNotificationsDelete: 'Radera notis',
    createPushNotificationTitle: 'Skapa pushnotis',
    editPushNotificationTitle: 'Redigera planerad pushnotis',
    pushNotificationField: 'Publiceringstid för notis',
    contentImageTitle: 'Bild till pushnotisen (valfri)',
    contentImageLabel: 'Rekommenderad storlek: 512x256 px. Format: jpg eller png',

    allOption: 'Alla',
    defaultTitle: 'Titel',
    defaultDescription: 'Beskrivning',
    topic: 'Ämne',
    deleteNotificationTitle: 'Ta bort schemalagd $name?',

    successRate: 'Framgångsfrekvens',
    successful: 'Lyckade',
    failed: 'Misslyckade',
    deliveryProgress: 'Leveransframsteg',
    notificationDetails: 'Notisinformation',
    sentAt: 'Skickades',
    createdAt: 'Skapades',
    successRateLabel: 'Framgångsfrekvens',
    statusFailed: 'Misslyckades',
    deliveryProgressLabel: 'Leveransframsteg',
  },
  news: {
    fieldNameDate: 'Datum',
    fieldNameType: 'Typ',
    fieldNameId: 'Id',
    fieldNameTitle: 'Titel',
    fieldNameDescription: 'Beskrivning',
    fieldNameNewsShow: 'Visa nyhet',
    fieldNameCommentsShow: 'Visa kommentarer',
    disableReactions: 'Inaktivera reaktioner för nyheter',
    enableReactions: 'Aktivera reaktioner för nyheter',
    enabledReactions: 'Reaktioner för nyheter är aktivt',
    disabledReactions: 'Reaktioner för nyheter är avaktiverat',
    updateRssLinkButton: 'Uppdatera RSS-länk',
    newsRSSLink: 'Nyheter RSS länk',
    addRSSLink: 'Lägg till RSS-länk',
    updateRSSLink: 'Uppdatera RSS-länk',
    publishButton: 'Publicera',
    errorMessageRSSLink:
      'Länk till nyheterna saknas eller är ogiltig (tex https:// saknas). Ändra länken och försök igen',
    pushNotificationColumn: 'Pushnotis',
  },
  polls: {
    fieldNameId: 'Id',
    fieldNameName: 'Namn',
    fieldNameCreated: 'Skapad',
    fieldNameTitle: 'Titel/Fråga',
    fieldNameType: 'Typ',
    fieldNameVotes: 'Antal röster',
    fieldNameMostVoted: 'Mest röstat',
    fieldNameLink: 'Länk',
    fieldNameStatus: 'Status',
    pollTypePlayerOfTheMatch: 'Matchens spelare',
    pollTypePlayerOfTheMonth: 'Månadens spelare',
    pollTypeCoachOfTheMonth: 'Månadens tränare',
    pollTypeQuiz: 'Quiz',
    pollTypeText: 'Valfri omröstning',
    addPoll: 'Skapa ny omröstning',
    newPlayerPoll: 'Skapa ny spelaromröstning',
    newCoachPoll: 'Skapa ny tränaromröstning',
    newQuiz: 'Skapa ny quiz',
    newTextPoll: 'Skapa ny valfri omröstning',
    addPollListTitle: 'Välj omröstningstyp',
    editPoll: 'Editera omröstning',
    deletePoll: 'Ta bort omröstningen',
    editQuiz: 'Editera quiz',
    deleteQuiz: 'Ta bort quiz',
    submitQuiz: 'Skapa quiz',
    listToolTipOngoing: '"Pågående" - Användare kan rösta',
    listToolTipUpcoming: '"Schemalagd" - Användare kan ej rösta ännu',
    listToolTipOFinished: '"Avslutad" - Omröstningen är avslutad',
    deletePollTitle: 'Ta bort omröstning $name?',
    pollDetailsTitle: 'Omröstningsdetaljer',
    pollNamePlayerTitle: 'Omröstningsnamn och tidsinställning',
    pollNamePlayerLabel: 'Ange omröstningsnamn',
    pollNamePlayerHelperText:
      'Syns endast i Superadmin, ej i appen. Använd något tydligt för admin, t.ex. "Matchens lirare Malmö FF - GAIS',
    pollNameCoachTitle: 'Omröstningsnamn och tidsinställning',
    pollNameCoachLabel: 'Ange omröstningsnamn',
    pollNameCoachHelperText:
      'Syns endast i Superadmin, ej i appen. Använd något tydligt för admin, t.ex. "Månadens tränare Malmö FF"',
    pollNameTextHelperText: 'Syns endast i Superadmin, ej i appen. Använd något tydligt för admin.',
    pollNameQuizTitle: 'Quiz-namn och tidsinställning',
    pollNameQuizLabel: 'Ange quiz-namn',
    pollNameQuizHelperText:
      'Syns endast i Superadmin, ej i appen. Använd något tydligt för admin, t.ex. "Quiz DIF - GAIS',
    pollTitleLabel: 'Ange titel / fråga',
    pollTextTitleLabel: 'Ange fråga',
    pollTitleHelperText: 'Titel/Fråga till supportrarna i appen. T.ex. "Rösta på matchens lirare"',
    pollTextTitleHelperText:
      'Används som fråga för din omröstning och visas för användarna, T.ex. Vem vinner matchen?',
    pollPlayerTimeStartTitle: 'Ange hur länge din omröstning ska vara öppen',
    pollQuizTimeStartTitle: 'Ange tidsintervallet då supportrarna kan svara på quizen',
    startTimeLabel: 'Välj startid',
    endTimeLabel: 'Välj sluttid',
    playerSelectTitle: 'Välj spelare man kan rösta på',
    coachSelectTitle: 'Välj tränare man kan rösta på',
    selectSquadLabel: 'Använd spelare från en matchtrupp',
    selectSquadText:
      'Använd denna typ till ex. "Matchens lirare". Kopplad till matchtruppen som presenteras 60 min innan matchen.',
    selectMatchLabel: 'Välj match',
    selectManuallyLabel: 'Välj spelare manuellt från hela truppdatabasen',
    selectManuallyText:
      'Använd denna typ till ex. en öppen spelarfråga som inte är kopplad till en match.',
    selectPlayersLabel: 'Välj spelare',
    selectCoachesLabel: 'Välj tränare',
    pollImageUploads: 'Bilduppladdningar',
    backgroundImageTitle: 'Bakgrundsbild (valfri)',
    quizBackgroundImageTitle: 'Master bakgrundsbild (valfri)',
    backgroundImageLabel: 'Rekommenderad storlek: 540x960 px. Format: jpg, png',
    backgroundImageRequired: 'Bakgrundsbild måste läggas till',
    sponsorImageTitle: 'Sponsorlogga (valfri)',
    sponsorImageLabel:
      'Logotyp med vit eller genomskinlig bakgrund. Rekommenderad storlek: Bilden bör vara dubbelt så bred som hög, t.ex. 200x100 px. Format: jpeg, png',
    questionBackgroundmageTitle: 'Bakgrundsbild (valfri)',
    questionBackgroundmageLabel1: 'Om tillagd så ersätter denna "Master bakgrundsbild".',
    questionBackgroundmageLabel2: 'Rekommenderad storlek: 540x960 px. Format: jpg, png',
    statusOngoing: 'Pågående',
    statusUpcoming: 'Schemalagd',
    statusFinished: 'Avslutad',
    createdTitle: 'Din nya omröstning är skapad',
    createdActive: 'Din omröstning är skapad och öppen mellan:',
    createdNextSteps: 'Nästa steg är att:',
    createdStepOne: 'Gå in på promos och skapa en ny omröstningspromo.',
    createdStepTwo:
      'Lägg till "Exponeringsyta - Omröstning" modulen under Innehåll och välj omröstningspromon. Tidsinställ promon enligt hur länge du vill att omröstningen ska synas i appen - glöm inte att lämna tid att kolla in resultatet!',
    createdStepThree:
      'Om du vill kan du skapa och schemalägga pushnotiser. 1) Skicka en pushnotis när omröstningen har öppnat. 2) Skicka en pushnotis när omröstningsresultaten är tillgängliga.',
    pollResultTitle: 'Statistik',
    pollResultVotes: 'Antal röster',
    pollResultList: 'Resultat',
    pollResultRow: '$percentage% ($count $votes)',
    pollResultVoteSingle: 'röst',
    pollResultVoteMany: 'röster',
    quizResultList: 'Resultat',
    quizResultRow: '$score rätt',
    saveValidationError:
      'Formuläret innehåller fel och kunde inte sparas. Kontrollera alla fält och försök igen.',
    editSuccess:
      'Sparningen lyckades. Det kan ta upp till två minuter innan dina ändringar syns i appen.',
    stepQuizOne: 'Quiz-detaljer',
    stepQuizTwo: 'Lägg in frågor',
    quizDetailsTitle: 'Röst $number ($score rätt)',
    quizQuestionTitle: 'Fråga ',
    quizQuestionAdd: 'Lägg till fråga ',
    quizRemoveQuestion: 'Ta bort fråga',
    quizQuestionType: 'Frågetyp',
    quizQuestionLabel: 'Ange fråga',
    quizQuestionTimeLimitLabel: 'Tidsgräns (valfri)',
    quizAlternativeTextTitle: 'Svarsalternativ',
    quizAlternativePlayersTitle: 'Välj spelare från truppdatabasen som svarsalternativ',
    quizAlternativeLabel: 'Alternativ ',
    quizAddAlternative: 'Lägg till alternativ',
    quizSelectTeamLabel: 'Välj lag',
    quizSelectPlayerLabel: 'Välj spelare',
    quizSelectPlayerAnswerLabel: 'Välj rätt svar',
    quizDescriptionTitle: 'Quiz-intro',
    quizDescriptionInfo: 'Om du inte vill använda ett quiz-intro, lämna båda fälten nedan tomma.',
    quizTitleLabel: 'Ange quiz-titel (valfri)',
    quizTitleHelperText: 'Används som titel för ditt quiz och visas för användarna.',
    quizDescriptionLabel: 'Ange quiz-beskrivning (valfri)',
    quizDescriptionHelperText:
      'Används som en kort beskrivning för ditt quiz och visas för användarna.',
    quizRewardTitle: 'Belöning',
    quizRewardInfo:
      'Användare som uppfyller villkoret ser meddelandet på en extra sida efter resultatet.',
    quizRewardSwitchLabel: 'Belöning för bra resultat',
    quizRewardComparisonLabel: 'Villkor',
    quizRewardAtLeast: 'Minst',
    quizRewardMoreThan: 'Fler än',
    quizRewardThresholdLabel: 'Antal',
    quizRewardThresholdSuffix: 'rätt svar',
    quizRewardTypeLabel: 'Typ av belöning',
    quizRewardTypeText: 'Endast text',
    quizRewardTypeVoucher: 'Text med rabattkod',
    quizRewardMessageLabel: 'Meddelande',
    quizRewardMessageHelperText: 'Visas på prissidan i appen. Max 500 tecken.',
    quizRewardVoucherCodeLabel: 'Rabattkod',
    quizRewardVoucherCodeHelperText:
      'Samma kod visas för alla som uppfyller villkoret. Max 50 tecken.',
    quizRewardThresholdTooHigh:
      'Belöningsvillkoret kräver fler rätt svar än quizet har frågor ($count). Ändra villkoret under Quiz-detaljer.',
    quizRewardSummary: 'Belöning: $comparison $threshold av $count rätt · $type',
    quizRewardSummaryAtLeast: 'minst',
    quizRewardSummaryMoreThan: 'fler än',
    quizRewardSummaryText: 'endast text',
    quizRewardSummaryVoucher: 'rabattkod',
    quizQuestionTextType: 'Valfri fråga',
    quizQuestionPlayerType: 'Spelarfråga',
    quizQuestionSelectMoreLabel: 'Välj flera spelare',
    textAlternativesTitle: 'Svarsalternativ',
    textAlternativeLabel: 'Alternativ ',
    toolTipAlternative: 'Markera som rätt svar',
    showVotes: 'Visa röster',
    downloadVotes: 'Exportera CSV',
    votersTitle: 'Röster',
    votersVoteNumber: 'Röst ',
    votersName: 'Namn:',
    votersEmail: 'E-postadress:',
    votersTabWinners: 'Vinströst',
    votersTabAll: 'Alla',
    votersNameMissing: 'Namn saknas',
    pushNotificationColumn: 'Pushnotis',
    exportToPushGroup: 'Exportera till push-grupp',
    pushGroupTitle: 'Exportera till push-grupp',
    pushGroupAudienceLabel: 'Vilka ska ingå?',
    pushGroupAudienceParticipants: 'Alla deltagare',
    pushGroupAudienceWinners: 'Vinnare (röstade på vinnande alternativ)',
    pushGroupAudienceWinnersQuiz: 'Vinnare (flest rätt)',
    pushGroupLimitWinners: 'Begränsa antal vinnare',
    pushGroupLimitLabel: 'Antal vinnare',
    pushGroupLimitInvalid: 'Ange ett heltal, minst 1',
    pushGroupPickLabel: 'Urval',
    pushGroupPickRandom: 'Slumpa',
    pushGroupPickEarliest: 'Först in',
    pushGroupNameLabel: 'Namn på push-gruppen',
    pushGroupDescriptionLabel: 'Beskrivning (valfri)',
    pushGroupDefaultDescription: 'Skapad från "$title"',
    pushGroupNameParticipants: 'Deltagare',
    pushGroupNameWinners: 'Vinnare',
    pushGroupOngoingWarning:
      'Omröstningen pågår fortfarande – gruppen blir en ögonblicksbild av rösterna just nu.',
    pushGroupSnapshotInfo:
      'Gruppen sparas med de användare som matchar urvalet just nu och uppdateras inte i efterhand.',
    pushGroupCreate: 'Skapa push-grupp',
    pushGroupCreated: 'Push-grupp skapad med $count användare',
    pushGroupOpenSegments: 'Visa målgrupper',
    pushGroupError: 'Kunde inte skapa push-grupp',
  },
  stories: {
    fieldNameId: 'Id',
    fieldNameThumbnail: 'Bild',
    fieldNameCreated: 'Skapad',
    fieldNameCaption: 'Caption',
    fieldNameType: 'Typ',
    fieldNameViews: 'Visningar',
    fieldNameStatus: 'Status',
    fieldNameShown: 'Visas',
    fieldNameReactions: 'Interaktioner',
    fieldNameComments: 'Kommentarer',
    fieldNamePushNotification: 'Pushnotis',
    addStory: 'Ny porträttvideo',
    editStory: 'Editera porträttvideo',
    deleteStory: 'Ta bort porträttvideo',
    deleteStoryTitle: 'Ta bort porträttvideo $name?',
    mediaTitle: 'Välj media',
    detailsTitle: 'Detaljer',
    scheduleTitle: 'Schemalägg',
    mediaVideoLabel: 'FotbollPlay URL',
    mediaVideoHelperText: 'Skriv din URL och klicka på validera.',
    detailsCaptionLabel: 'Caption',
    detailsCaptionHelperText:
      'Används som titel/beskrivning för ditt video porträtt. Håll det kort och tydligt.',
    detailsLinkToggle: 'Lägg in en länk',
    detailsUrlLabel: 'URL',
    detailsButtonLabel: 'Text på knappen',
    detailsOpenExternallyToggle: 'Öppna i extern webbläsare',
    detailsOpenExternallyHelperText: 'Annars öppnas länken i appen.',
    scheduleLabel: 'Välj tidpunkt',
    statusPublished: 'Publicerad',
    statusScheduled: 'Schemalagd',
    statusHidden: 'Dold',
    typeVideo: 'Porträttvideo',
    typeImage: 'Bild',
    toolTipPublished: '"Publicerad" - Visas för användarna',
    toolTipScheduled: '"Schemalagd" - Visas inte ännu för användarna',
    previewTitle: 'Förhandsgranska',
    previewPublishedText: 'Publicerad $time',
    globalToggleReactions: 'Tillåt sociala interaktioner',
    globalToggleComments: 'Tillåt kommentarer',
  },
  matches: {
    startDate: 'Matchstart',
    matchId: 'Id',
    homeTeam: 'Hemmalag',
    visitingTeam: 'Bortalag',
    result: 'Resultat',
    stats: 'Statistik',
    status: 'Status',
    round: 'Omgång',
    minute: 'Matchminut',
    description: 'Beskrivning',
    type: 'Typ',
    source: 'Källa',
    rating: 'TC-rating',
    league: 'Liga',
    season: 'Säsong',
    arena: 'Arena',
    spectators: 'Åskådare',
    referee: 'Domare',
    fogisId: 'Fogis Id',
    public: 'Synlig',
    homeCorners: 'Hörnor hemmalag',
    homeFinishes: 'Avslut hemmalag',
    homeFreeKicks: 'Frisparkar hemmalag',
    homeOffsides: 'Offsides hemmalag',
    homeRedCards: 'Röda kort hemmalag',
    homeShotsOnGoal: 'Skott på mål hemmalag',
    homeSubstitutions: 'Byten hemmalag',
    homeYellowCards: 'Gula kort hemmalag',
    visitingCorners: 'Hörnor bortalag',
    visitingFinishes: 'Avslut bortalag',
    visitingFreeKicks: 'Frisparkar bortalag',
    visitingOffsides: 'Offsides bortalag',
    visitingRedCards: 'Röda kort bortalag',
    visitingShotsOnGoal: 'Skott på mål bortalag',
    visitingSubstitutions: 'Byten bortalag',
    formation: 'Formation',
    lineupMissing: 'Laguppställning saknas',
    matchSettings: 'Matchinställningar',
    statsMissing: 'Statistik saknas',
    pauseNotifications: 'Pausa notifikationer',
    hideBallPossesion: 'Dölj bollinnehav',
    hideDistance: 'Dölj löpdistans',
    hideMatchTime: 'Dölj matchtid',
    hideMaxSpeed: 'Dölj maxhastighet',
    playerStatsHidden: 'Dold',
    showInterruptedMatchInformation: 'Visa information om matchen är avbruten',
    interruptedMatchText: 'Information om matchen är avbruten',
    pushNotificationColumn: 'Pushnotis',
  },
  eventType: {
    PERIOD_RESULT: 'Slut på halvlek',
    PERIOD_START: 'Halvlek startade',
    FREE_KICK: 'Frispark',
    FINISH: 'Avslut',
    CORNER: 'Hörna',
    OFFSIDE: 'Offside',
    PENALTY_KICK: 'Straff',
    PENALTY_GOAL: 'Straffmål',
    PENALTY_MISSED: 'Straffmiss',
    PENALTY_GOAL_10_M: 'Mål på straff från 10 meter',
    PENALTY_SHOOTING_GOAL: 'Straffläggning, mål',
    PENALTY_SHOOTING_MISS: 'Straffläggning, miss',
    GOAL: 'Mål',
    SUBSTITUTION: 'Byte',
    RED_CARD: 'Rött kort',
    WARNING: 'Gult kort',
    SHOT: 'Avslut',
    SHOT_ON_TARGET: 'Avslut på mål',
    PENALTY: 'Rött kort',
    TIMEOUT: 'Timeout',
  },
  mappings: {
    mappingsTitle: 'Mappning',
    displayName: 'Visningsnamn',
    id: 'Id',
    leagueStartYear: 'Årtal',
    everySportId: 'Everysport Id',
    everySportIds: 'Everysport Idn',
    everySportLeagueId: 'Everysport League Id',
    fogisId: 'Fogis Id',
    fogisIds: 'Fogis Idn',
    smcId: 'SMC Id',
    forzasysId: 'Forzasys Id',
    teams: 'Lag',
    gender: 'Genus',
    name: 'Namn',
    sport: 'Sport',
    addRow: 'Lägg till',
    teamAbbrv: 'Lag',
    addIdOrAbbrv: 'Id / Abbrv',
    selectType: 'Välj typ',
  },
  messagesViewer: {
    unitbetValuestats: 'Unibet',
    upcomingMessageType: 'Kommande',
    messages: 'Meddelanden',
    type: 'Typ',
    created: 'Skapad',
    expired: 'Utgå',
    message: 'Meddelande',
    homeTeam: 'Hemmalag',
    awayTeam: 'Bortalag',
    numberOfMessages: 'Antal meddelande',
    filterMessages: 'Filtrera meddelande',
    selectMessageType: 'Välj typ av meddelande',
    filterByApp: 'Filtrering',
    numberOfMatches: 'Antal matcher',
    totalMessagesSent: 'Antal skickade meddelande',
    averageMessagesPerMatch: 'I genomsnitt antal meddelande per match',
  },
  fcmTopicExplorer: {
    enterFCMToken: 'Ange FCM-token',
    teamNewsFor: 'Lagnyheter för: ',
    teamEventsFor: 'Laghändelser för: ',
    clubStreamsFor: 'Klubbström för: ',
  },
  tickerConfigurator: {
    ticketTitle: 'Biljetter',
    teamAbbrv: 'Lag',
    everySportId: 'Everysport Id',
    tickerUrl: 'Biljettlänk',
  },
  timeMachine: {
    pickHistory: 'Välj historik för att jämföra',
    noHistoryForDocument: 'Dokumentet har ingen historik',
  },
  usersAndPermissions: {
    addUser: 'Lägg till användare',
    email: 'E-postadress',
    emailNotFound: 'E-posten hittades inte',
    noTeamsLeft: 'Det finns inga lag över för denna användare. Användaren tas därför bort',
    teamsModifiedSuccessfully: 'Rättigheterna för $updatedTeams har uppdaterats',
    noTeamsAvailable: 'Inga lag tillgängliga',
    editTeamPermissions: 'Editera rättigheter',
    lossOfAdminRights:
      'Observera att detta leder till att användaren blir av med adminrättigheterna',
    enterEmail: 'Skriv e-postadress',
    selectTeam: 'Välj lag',
    leagueApps: 'Liga-appar',
    removeUser: 'Ta bort användaren $email?',
  },
  account: {
    email: 'E-post',
  },
  promos: {
    promoEmpty: 'tom',
    promoTooltip: 'Promo $promoValue är ansluten till denna modulen',
    promoVideoUrl: 'Länk till videoklipp',
    promoVideoTitle: 'Titel (valfri)',
  },
  wifi: {
    arena: 'Arena',
    pushNotifications: 'Pushnotiser',
    appWifiCard: 'App Wifi-kort',
    arenaConfig: 'Arena konfiguration',
    networkConfigurator: 'Nätverkskonfiguration',
    editNetworkConfig: 'Editera nätverk',
    editArenaConfig: 'Editera arena',
    externalIpConfig: 'Extern IP-konfiguration',
    transticketInstanceId: 'Transticket Instans Id',
    homeTeamSelector: 'Hemmalagväljare',
    newChannel: 'Ny kanal',
    addNewChannel: 'Lägg till ny kanal',
    headerKey: 'Nyckel',
    headerArena: 'Arena',
    headerRanges: 'IP-intervall',
    arenaNetworkConfigurator: 'Arenanätverkskonfiguration',
    addNewExternalIp: 'Lägg till nytt externt ip',
    addToList: 'Lägg till listan',
    labelNewExternalIpName: 'Nytt externt IP-namn',
    labelNewExternalIp: 'Nytt externt ip',
    labelColor: 'Färg',
    labelBackgroundImage: 'Bakgrundsbild',
    labelActionText: 'Action-text',
    labelBody: 'Body',
    labelHeader: 'Titel',
    channels: 'Kanaler',
    incorrectFormatIpRange: 'Ej giltigt format eller IP-intervall finns redan',
    incorrectNameKey: 'Namn/nyckel finns redan',
    incorrectNameKeyFormatIpRange:
      'Namn/nyckel finns redan och ej giltigt namn/nyckel format eller IP-intervall finns redan',
  },
  appConfig: {
    selectApp: 'Välj app',
    baseConfig: 'Appkonfiguration',
    saveBaseConfig: 'Spara appkonfiguration',
    videoPlayerBranding: 'Branding av videospelare',
    saveVideoPlayBranding: 'Spara videospelare branding',
    currentSeason: 'Nuvarande säsong',
    league: 'Liga',
    useAntourageClubStreams: 'Använd Antourage Clubstreams',
  },
  sceneModules: {
    promo: 'Exponeringsyta',
    promoImages: 'Exponeringsyta - Bilder',
    promoVideo: 'Exponeringsyta - Video',
    promoPoll: 'Exponeringsyta - Omröstning',
    promoFlarie: 'Exponeringsyta - Flarie',
    promoSubscription: 'Exponeringsyta - Prenumeration',
    unibetPromoWebview: 'Banner från Unibet',
    svenskaSpelPromo: 'Banner från Svenska Spel',
    standingsTable: 'Tabellen',
    teamPlayersBanner: 'Banner för truppen',
    teamPlayers: 'Modul för truppen',
    clubStreamsArchive: 'Tidigare live-sändningar',
    notificationCard: 'Modul för notifieringar',
    sideScrollingNews: 'Nyhetsmodul',
    sideScrollingTeams: 'Lagmodul',
    matchCard: 'Nästa match i ligan',
    matchListCard: 'Lista med aktuella matcher',
    leaderTableCard: 'Assist/skytte ligan',
    clubStreams: 'Modul vid live-sändning',
    appPromo: 'Banner för appnedladdning',
    appInfo: 'Info om app',
    wifiCard: 'Info om wifi',
    links: 'Modul med länkar',
    latestHighlightsPlusVideos: 'Senaste highlights plus videor',
    fotbollPlayVideos: 'Fotboll Play videor',
    poll: 'Omröstning',
    stories: 'Porträttvideor',
    editorial: 'Artiklar',
    officialHighlightsReels: 'Officiella sammandrag',
  },
  allPlayers: {
    backButton: 'Tillbaka',
    CS: 'inkluderar',
    NCS: 'inkluderar inte',
    EQ: 'equal',
    NEQ: 'not equal',
    EQ_NULL: 'saknas i',
    NEQ_NULL: 'finns i',
    equalsToAnyValue: 'Finns',
    equalsToEmptyValue: 'Saknas',
    toAnyValue: 'finns i',
    toEmptyValue: 'saknas i',
    filter: 'Filtrera',
    league: 'Liga',
    playerEfId: 'Ef Id',
    playerEsId: 'Everysport Id',
    playerFogisId: 'Fogis Id',
    playerForzasysId: 'Forzasys Id',
    playerImage: 'Spelarbild',
    playerName: 'Spelarnamn',
    playerOptaId: 'Opta Id',
    playerPosition: 'Position',
    playerShirtNumber: 'Tröjnummer',
    playerSmcId: 'SMC Id',
    searchButton: 'Filtrera',
    searchContent: 'Fritext filtrering',
    selectedItems: 'objekt',
    team: 'Lag',
    season: 'Säsong',
    searchContentLabel: 'Spelardata',
    searchPlaceholderText: 'Filtrera på valfri datapunkt...',
  },
  squad: {
    squad: 'Trupp',
    add: 'Lägg till',
    uploadSquadImages: 'Ladda upp spelarbilder',
    addPlayer: 'Lägg till spelare',
    removePlayer: 'Ta bort spelare',
    createNewSquad: 'Skapa ny trupp',
    createSquad: 'Skapa trupp',
    removeSquad: 'Ta bort trupp',
    season: 'Säsong',
    player: 'Spelare',
    edit: 'Redigera',
    searchFogisId: 'Sök på Fogis id',
    cancel: 'Avbryt',
    selectSeasonForSquad: 'Ange säsong du vill skapa trupp för, tex 2026',
    save: 'Spara',
    editInfo: 'Redigera information',
    editStats: 'Redigera statistik',
    info: 'Info',
    stats: 'Statistik',
    remove: 'Ta bort',
    removePlayerFromSquad: 'Ta bort $name från truppen ($team - $season) ?',
    removeStats: 'Är du säker att du vill ta bort raden?',
    yesRemove: 'Ja, ta bort',
    noSquadCreated: 'Ingen trupp skapad',
    missingInformation: 'Information saknas',
    playerImage: 'Spelarbild',
    teamPlayersEmpty: 'Inga spelare tillgängliga',
    squadEmpty: 'Inga spelare tillagda',
    status: 'Status',
    healthStatus: 'Hälsotillstånd',
    selectPlayer: 'Välj spelare',
    fogisInfo: 'Observera att om en spelare saknas behöver denna först läggas till i Fogis',
    uploadPlayerImagesInfo:
      'Välj bilder, kontrollera att de uppfyller kraven och välj spelare på respektive bild. Bildformat som accepteras är JPEG, PNG, GIF och WEBP.',
  },
  squadPlayer: {
    fullName: 'Fullständigt namn (Fogis)',
    givenName: 'Förnamn',
    surName: 'Efternamn',
    nickName: 'Smeknamn',
    displayName: 'Visningsnamn',
    birthDay: 'Födelsedag',
    nationality: 'Nationalitet',
    position: 'Position',
    agent: 'Agent',
    youthClub: 'Moderklubb',
    age: 'Ålder',
    sex: 'Kön',
    height: 'Längd',
    weight: 'Vikt',
    shirtNumber: 'Nummer',
    smcId: 'SMC Id',
    fogisId: 'Fogis Id',
    esId: 'Everysport Id',
    forzasysId: 'Forzasys Id',
    optaId: 'Opta Id',
    active: 'Aktiv',
    contract: 'Kontrakt',
    contractUntil: 'Kontrakt utgår',
    contractType: 'Kontraktyp',
    joined: 'Värvades',
    facebook: 'Facebook',
    instagram: 'Instagram',
    twitter: 'Twitter',
    primaryPosition: 'Primär position',
    otherPosition: 'Andra position',
    foot: 'Fot',
    onLoan: 'Utlånad',
    temporary: 'Inlånad',
    regular: 'Ordinarie',
    injured: 'Skadad',
    notInjured: 'Ej skadad',
    healthStatus: 'Hälsotillstånd',
    status: 'Status',
    left: 'Vänsterfot',
    right: 'Högerfot',
    moreStats: 'Mer statistik',
  },
  squadPlayerHealth: {
    status: 'Nuvarande tillstånd',
    injured: 'Skadad',
    notInjured: 'Ej skadad',
    description: 'Beskrivning',
    fromDate: 'Skadad från',
    toDate: 'Skadad till',
  },
  squadPlayerStats: {
    seasonYears: 'Säsong',
    seasonStartYear: 'Säsong start',
    seasonEndYear: 'Säsong slut',
    leagueName: 'Liga',
    teamName: 'Klubb',
    goals: 'Mål',
    goalsConceded: 'Avslut',
    points: 'Poäng',
    assists: 'Assist',
    gamesPlayed: 'Matcher',
    redCards: 'Röda kort',
    yellowCards: 'Gula kort',
    minutesPlayed: 'Minuter spelade',
    subins: 'Inbyten',
    subout: 'Utbyten',
    cleanSheet: 'Höll nollan',
  },
  squadPlayerTabs: {
    information: 'Information',
    stats: 'Statistik',
    social: 'Social media',
    health: 'Hälsotillstånd',
    contract: 'Kontrakt',
    data: 'Data',
  },
  squadPlayerPositions: {
    Goalkeeper: 'Målvakt',
    Defender: 'Back',
    Back: 'Back',
    'Centre-Back': 'Mittback',
    'Left-Back': 'Vänsterback',
    'Right-Back': 'Högerback',
    Midfielder: 'Mittfältare',
    Midfield: 'Mittfältare',
    'Defensive Midfield': 'Defensiv mittfältare',
    'Central Midfield': 'Central mittfältare',
    'Attacking Midfield': 'Offensiv mittfältare',
    'Attacking Central Midfield': 'Offensiv central mittfältare',
    'Left Winger': 'Vänsterytter',
    'Right Winger': 'Högerytter',
    'Centre Forward': 'Centerforward',
    Forward: 'Forward',
  },
  staff: {
    member: 'Person',
    addMember: 'Lägg till person',
    editMember: 'Redigera person',
    givenName: 'Förnamn',
    surName: 'Efternamn',
    displayName: 'Visningsnamn',
    role: 'Roll',
    roleDisplayName: 'Annan roll',
    birthDay: 'Födelsedag',
    nationality: 'Nationalitet',
    empty: 'Ledarstaben är tom',
    removeMemberFromTeam: 'Ta bort $name från ledarstaben?',
    givenNameRequired: 'Förnamn måste fyllas i',
    surNameRequired: 'Efternamn måste fyllas i',
    selectStaffMember: 'Välj person',
    uploadImages: 'Ladda upp bilder',
    uploadImagesInfo:
      'Välj bilder, kontrollera att de uppfyller kraven och välj person för respektive bild. Bildformat som accepteras är JPEG, PNG, GIF och WEBP.',
  },
  staffRoles: {
    Coach: 'Tränare',
    'Head Coach': 'Huvudtränare',
    'Assistant Coach': 'Assisterande tränare',
    'Goalkeeper Coach': 'Målvaktstränare',
    Physiotherapist: 'Fysioterapeut',
    Doctor: 'Lagläkare',
    'Team Manager': 'Lagansvarig',
    Analyst: 'Analytiker',
    Scout: 'Scout',
    Other: 'Annan roll',
  },
  fotbollPlayCategories: {
    pressConference: 'Presskonferens',
    match: 'Match',
    training: 'Träning',
    practiceMatches: 'Träningsmatcher',
    preseason: 'Försäsong',
    highlights: 'Sammandrag',
    studioProgram: 'Studioprogram',
    reportage: 'Reportage',
    series: 'Serier',
    interview: 'Intervju',
    clubMeeting: 'Klubbmöte',
    archive: 'Arkiv',
    sustainability: 'Hållbarhet',
    education: 'Utbildning',
    all: 'Alla',
  },
  social: {
    tabComments: 'Kommentarer',
    tabReactions: 'Reaktioner',
    contentNews: 'Nyheter',
    reactionsTitle: 'Reaktioner',
    reactionsTotal: 'reaktioner totalt',
    reactionsFieldLatest: 'Senaste',
    reactionsFieldContentType: 'Innehållstyp',
    reactionsFieldContent: 'Innehåll',
    reactionsFieldNumberOfReactions: 'Antal gilla markeringar',
    reactionsFieldNumberOfComments: 'Antalet kommentarer',
    commentsTitle: 'Kommentarer',
    commentsTotal: 'kommentarer totalt',
    commentsFieldAuthor: 'Författare',
    commentsFieldDate: 'Datum',
    commentsFieldComment: 'Kommentar',
    commentsFieldContentType: 'Innehållstyp',
    commentsFieldShow: 'Visa kommentar',
    commentsEnableLabel: 'Tillåt kommentarer',
    commentsToggleWarningTitle: 'Vill du inaktivera kommentarerna för hela appen?',
    commentsToggleWarningText:
      'OBS! Inaktivera alla kommentarer i appen utan hänsyn till tidigare inställningar. Använd endast i nödfall och justera istället kommentarsmöjligheterna per funktion.',
    commentSettingsLabels: {
      disableComments: 'Tillåt kommentarer',
      disableCommentsNews: 'Tillåt kommentarer för Nyheter',
      disableCommentsStories: 'Tillåt kommentarer för Porträttvideor',
      disableCommentsArticles: 'Tillåt kommentarer för Artiklar',
    },
  },
  faq: {
    articles: 'Artiklar',
    variables: 'Variabler',
    fieldNameSortIndex: 'Sortering',
    fieldNameSlug: 'Slug',
    fieldNameTitle: 'Rubrik',
    fieldNameHtml: 'Text',
    sortIndexHelperText: 'Artiklarna sorteras i nummerordning, lämna tomt för att avpublicera',
    slugFieldRequired: 'Slug måste fyllas i och vara unik',
    titleFieldRequired: 'Rubrik måste fyllas i',
    editArticle: 'Redigera artikel',
    variableName: 'Namn',
    variableValue: 'Värde',
    createArticle: 'Skapa artikel',
  },
  theme: {
    sectionId: 'Identifiering',
    sectionCard: 'Komponent',
    sectionButton: 'Interaktion',
    sectionHeader: 'Topbar',
    sectionAddition: 'Tillägg',
    colorNames: {
      idMain: 'ID-färg',
      idForeground: 'Förgrund',
      idContrast: 'Kontrast accent',
      componentBackground: 'Komponentbakgrund',
      componentForeground: 'Komponentförgrund',
      componentForegroundId: 'Komponentförgrund ID-färg',
      componentBorder: 'Ram',
      buttonBackground: 'Knappbakgrund',
      buttonForeground: 'Knapptext',
      topBarBackground: 'Topbar bakgrund',
      topBarForeground: 'Topbar förgrund',
      topBarContrast: 'Topbar kontrast',
      socialHeart: 'Hjärta',
    },
    colorTexts: {
      idMain:
        'En färg som representerar er klubb. Denna färg kommer användas som bakgrundsfärg i appen.',
      idForeground:
        'Denna färg används som förgrund mot ID-färgen, t.ex. text på bakgrunden. Detta betyder att det är viktigt att denna färg har bra kontrast mot ID-färgen.',
      idContrast:
        'En kontrastfärg till ID-färgen. Denna kulör används för att lyfta fram små element i användargränssnittet så som knappar, linjer, vald tabb osv.',
      componentBackground:
        'Användargränssnittet är uppbyggt av komponenter, de flesta är moduler med olika innehåll, t.ex. tabellen. Denna färg är bakgrunden till dessa komponenter.',
      componentForeground:
        'Denna färg används som förgrund i komponenterna t.ex. som textfärg. Detta betyder att det är vikitigt att denna färg har bra kontrast mot komponentbakgrunden.',
      componentForegroundId:
        'Denna används som accentfärg på utvalda platser, t ex där en toggle är i “påslaget” läge.',
      componentBorder:
        'Används till att urskilja komponenten från bakgrunden och som avskiljare mellan olika delar i en komponent. Denna färg bör ha bra kontrast mot komponentbakgrunden.',
      buttonBackground: 'Färg på appens primära knappar.',
      buttonForeground:
        'Textfärgen på appens primära knappar. Se till att den har bra kontrast mot knappbakgrunden.',
      topBarBackground: 'Denna färg används som avvikande bakgrundsfärg för topbaren i appen.',
      topBarForeground:
        'Denna färg används som text-/ikonfärg i er topbar. Detta betyder att det är viktigt att denna färg har bra kontrast mot topbar bakgrund.',
      topBarContrast:
        'Topbar kontrast används för att lyfta upp specifika objekt i topbar. Även denna färg bör har bra kontrast mot topbar bakgrund.',
      socialHeart: 'Färg som används på hjärtat när man gillat innehåll som har gillafunktion.',
    },
  },
  articles: {
    id: 'ID',
    createdAt: 'Skapad',
    updatedAt: 'Uppdaterad',
    articles: 'Artikellista',
    authors: 'Skribenter',
    fieldNameTitle: 'Rubrik',
    fieldNameExcerpt: 'Ingress',
    fieldNameDescription: 'Beskrivning',
    fieldNamePublishedAt: 'Publiceringstid',
    fieldNamePushNotification: 'Skicka ut pushnotis vid publicering till valda appar',
    fieldNameArchivedAt: 'Avpubliceringstid',
    fieldNameImage: 'Bild',
    fieldNameAuthors: 'Skribenter',
    fieldNameAuthorName: 'Namn',
    fieldNameAuthorEmail: 'E-post',
    fieldNameAuthorImage: 'Bild',
    fieldNameAppAbbrvs: 'Appar',
    fieldNameAuthorArticleCount: 'Antal artiklar',
    titleFieldRequired: 'Rubrik måste fyllas i',
    authorNameRequired: 'Namn måste fyllas i',
    authorEmailRequired: 'E-post måste fyllas i',
    abbrvsRequired: 'Minst en app måste väljas',
    createArticle: 'Skapa artikel',
    createAuthor: 'Skapa skribent',
    editArticle: 'Redigera artikel',
    previewArticle: 'Förhandsgranska artikel',
    editAuthor: 'Redigera skribent',
    status: 'Status',
    fieldNameContent: 'Text',
    variableName: 'Namn',
    variableValue: 'Värde',
    draft: 'Utkast',
    scheduled: 'Schemalagd',
    published: 'Publicerad',
    archived: 'Arkiverad',
    scheduledToPublishAt: 'Schemalagd för publicering',
    pushNotificationColumn: 'Pushnotis',
  },
  appMenu: {
    listTitle: 'Navigationslista',
    menuItemTitle: 'Ikon och namn',
    menuItemAdd: 'Lägg till menyval',
    menuItemRemove: 'Tabort',
    menuItemLink: 'Länk',
    menuItemSelection: 'Innehåll',
    menuItemClose: 'Stäng',
    menuItemEdit: 'Redigera',
    menuItemTypeUnibet: 'App - Unibet',
    menuItemTypeFantasy: 'App - Fantasy',
    menuItemTypeMatches: 'App - Matcher',
    menuItemTypeCustomUrl: 'Extern URL länk',
    menuItemPlaceholderName: 'Namn',
    menuItemPlaceholderUrl: 'https://www.svenskelitfotboll.se',
    configTitle: 'Konfiguration',
    previewTitle: 'Förhandsgranskning',
  },
  announcements: {
    createAnnouncement: 'Skapa meddelande',
    editAnnouncement: 'Editera meddelande',
    fieldNameTitle: 'Rubrik',
    fieldNameBody: 'Innehåll',
    fieldNameLink: 'Länk',
    fieldNameLinkText: 'Länk Innehåll',
    fieldNameAbbrv: 'App',
    fieldNameScene: 'Placering i app',
    fieldNameType: 'Typ',
    fieldNameShow: 'Visa',
    titleFieldRequired: 'Rubrik måste fyllas i',
    typeFieldRequired: 'Typ måste fyllas i',
    sceneMyPage: 'KONTO',
    sceneStartPage: 'STARTSCENE',
    optionWarning: 'Varning',
    optionInfo: 'Information',
    all: 'Alla',
  },
};

export default svStrings;
